import { useLoadedPageAnalytics } from 'utils/hooks/use-analytics';
import DescriptiveIntro from './partials/DescriptiveIntro/DescriptiveIntro.component';
import PendingSessionsList from './partials/PendingSessionsList/PendingSessionsList.component';
import StatsSummary from './partials/StatsSummary/StatsSummary.component';
import { PendingSessionsGameModalContainer } from './style/BannerPendingGameModal.style';

const PendingSessionsGameModalBody = () => {
  useLoadedPageAnalytics({
    pageName: 'sessioni-pending',
    trackOnce: true,
  });
  return (
    <>
      <PendingSessionsGameModalContainer>
        <DescriptiveIntro />
        <StatsSummary />
        <PendingSessionsList />
      </PendingSessionsGameModalContainer>
    </>
  );
};
export default PendingSessionsGameModalBody;
